import React, {useState, useEffect} from 'react';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import Api from '../../../api/SMPFetchHelper';
import {SessionDataGetSchema} from '../../../api/DBSchema/SessionData';
import {useSMCErrorHandler} from '../../../utils/errorUtils';
import ImportSMPStepOne from './ImportSMPStepOne';
import ImportSMPStepTwo from './ImportSMPStepTwo';

export const CertificateHandlingValues = {
    retain: 'retain',
    import: 'import',
    revoke: 'revoke'
};

function ImportSMPModal({
    isOpen = false,
    onRequestClose
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const [availableDomains, setAvailableDomains] = useState([]);
    const [editorStep, setEditorStep] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    
    const [fileToImport, setFileToImport] = useState(null);

    const [doOverrideExistingData, setDoOverrideExistingData] = useState(false);
    const [certificateHandling, setCertificateHandling] = useState(CertificateHandlingValues.retain);
    
    const [doImportIntoAllDomains, setDoImportIntoAllDomains] = useState(true);
    const [domainToImportTo, setDomainToImportTo] = useState('');


    const pageParams = {
        availableDomains,
        fileToImport, setFileToImport,
        doOverrideExistingData, setDoOverrideExistingData,
        certificateHandling, setCertificateHandling,
        doImportIntoAllDomains, setDoImportIntoAllDomains,
        domainToImportTo, setDomainToImportTo
    };

    // Fetch list of all portals
    useEffect(() => {
        Api.getSessionData({attributes: [
            SessionDataGetSchema.allPortals
        ]})
        .then(resp => {
            const respData = resp.data;
            const allPortals = respData.allPortals;
            setAvailableDomains(allPortals);
            if (allPortals && allPortals.length) {
                setDomainToImportTo(allPortals[0]);
            }
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            setErrorMessage(errorMessage);
        })
    }, [getErrorMessage]);

    // Reset all values on open
    useEffect(() => {
        if (isOpen) {
            setEditorStep(0);
            setErrorMessage('');
            setFileToImport(null);
            
            if (availableDomains && availableDomains.length) {
                setDomainToImportTo(availableDomains[0]);
            } else {
                setDomainToImportTo('');
            }

            setDoOverrideExistingData(false);
            setCertificateHandling(CertificateHandlingValues.retain);
            setDoImportIntoAllDomains(true);
            setDomainToImportTo('');            
        }
    }, [isOpen, availableDomains]);

    const onFinish = () => { }

    let EditorBody = () => null;

    switch (editorStep) {
        case 0:
            EditorBody = ImportSMPStepOne;
            break;
        case 1:
            EditorBody = ImportSMPStepTwo;
            break;
        default:
            onRequestClose();
            break;
    }

    return (
        <SMCModal
            isOpen={isOpen}
            width={710}
            height={540}
            title={t('SMC_SYSOPS_IMPWIZ_TITLE')}
            onRequestClose={onRequestClose}
            hasError={!!errorMessage}
            errorMessage={errorMessage}
        >
            <EditorBody
                onCancel={onRequestClose}
                onNext={() => setEditorStep(step => step+1)}
                onBack={() => setEditorStep(step => step-1)}
                onFinish={onFinish}
                pageParams={pageParams}
            />
        </SMCModal>

    );
}

export default ImportSMPModal;